import styled from 'styled-components';

export const AddFormSC = styled.form<{ position?: 'left' | 'right' }>`
  display: flex;
  flex-direction: column;
  flex: 1;

  padding: 40px;
  position: relative;
  background: white;
  box-shadow: 0 2px 15px rgba(51, 61, 108, 0.1);
  border-radius: 24px;

  .content {
    overflow-y: visible;
    background: white;
    border-radius: 0 0 5px 5px;
    width: 100%;

    .ui-react-select__menu-list {
      max-height: 150px;
    }

    .time-wrapper {
      display: flex;
      align-items: center;
      margin-bottom: 24px;

      label {
        margin: 0;
        margin-right: 13px;
        white-space: nowrap;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;

        /* identical to box height, or 143% */

        color: #464b5d;
      }

      .rc-picker-range .rc-picker-input,
      .rc-picker-input {
        min-width: unset;
      }

      .rc-picker-input {
        height: 100%;
      }

      .rc-picker-input > input {
        padding: 4px 3px;
      }

      .rc-picker {
        width: 118px;
      }

      .rc-picker,
      .rc-picker-range {
        height: 47px;
      }

      .rc-picker-range-separator {
        margin-top: 7px;
      }

      .time-pill {
        width: fit-content;
        padding: 4px 16px;
        margin-left: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #e0e1e9;
        border-radius: 14px;
        white-space: nowrap;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 20px;

        /* or 167% */

        color: #464b5d;
      }
    }

    .description-wrapper {
      margin-bottom: 32px;
    }

    .repeat-form {
      margin-top: 28px;
      margin-left: 36px;

      .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .small {
          margin-bottom: 0;
        }
      }
    }
  }

  .footer {
    position: sticky;
    bottom: 0;
    z-index: 0;
    border-radius: 0 0 5px 5px;

    .count-error {
      margin-bottom: 24px;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;

      /* identical to box height, or 143% */

      color: #464b5d;

      svg {
        margin-right: 8px;
      }
    }

    .form-actions {
      display: flex;
      align-items: center;
      justify-content: space-between;

      button:first-child {
        margin-right: 27px;
      }
    }
  }
`;
